import { css } from "styled-system/css";
import type { ReactNode } from "react";

export function EmptyState({
  title,
  description,
  icon,
}: {
  title: string;
  description?: string;
  icon?: ReactNode;
}) {
  return (
    <div
      className={css({
        rounded: "xl",
        borderWidth: "1px",
        borderStyle: "dashed",
        borderColor: "border.DEFAULT",
        bg: "bg.card",
        p: "10",
        textAlign: "center",
      })}
    >
      {icon ? (
        <div className={css({ fontSize: "2.5rem", mb: "3", opacity: 0.85 })} aria-hidden>
          {icon}
        </div>
      ) : null}
      <p className={css({ fontWeight: "semibold", color: "fg.DEFAULT" })}>{title}</p>
      {description ? (
        <p className={css({ fontSize: "sm", color: "fg.muted", mt: "2", maxW: "md", mx: "auto" })}>{description}</p>
      ) : null}
    </div>
  );
}
